export default __webpack_public_path__ + "static/media/full_video.db517cc8.png";